"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccordionContainer = void 0;
const react_1 = __importDefault(require("react"));
const spa_core_1 = require("@episerver/spa-core");
const Accordion_1 = __importDefault(require("react-bootstrap/Accordion"));
const AccordionContainer = (props) => {
    var _a, _b;
    const ctx = (0, spa_core_1.useEpiserver)();
    const styles = {};
    if (((_a = props.data.backgroundColor) === null || _a === void 0 ? void 0 : _a.value) && props.data.backgroundColor.value !== '')
        styles.backgroundColor = props.data.backgroundColor.value;
    let cssClasses = ['accordionBlock', 'row', 'mb-10', (_b = props.data.fontColor) === null || _b === void 0 ? void 0 : _b.value];
    return react_1.default.createElement(Accordion_1.default, { className: cssClasses.join(' '), style: styles },
        react_1.default.createElement(spa_core_1.Components.ContentArea, { data: props.data.mainContentArea, context: ctx, noWrap: true }));
};
exports.AccordionContainer = AccordionContainer;
exports.default = exports.AccordionContainer;
